// @flow

export default {
  VIEW: 'view',
  CLICK: 'click',
  SCROLL: 'scroll',
  RESIZE: 'resize',
  CHANGE: 'change',
  LOAD: 'load',
  SWIPE: 'swipe',
  SWIPE_LEFT: 'swipeleft',
  SWIPE_RIGHT: 'swiperight',
  POPSTATE: 'popstate',
  MOUSEDOWN: 'mousedown',
  MOUSEUP: 'mouseup',
  INPUT: 'input',
  BLUR: 'blur',
  SUBMIT: 'submit',
  KEY_UP: 'keyup',
  KEY_DOWN: 'keydown',
  MOUSE_ENTER: 'mouseenter',
  MOUSE_OVER: 'mouseover',
  MOUSE_MOVE: 'mousemove',
  MOUSE_LEAVE: 'mouseleave',
  FOCUS: 'focus',
  DOUBLE_TAP: 'tap',
  TOUCH_START: 'touchstart',
  TOUCH_MOVE: 'touchmove',
  TOUCH_END: 'touchend',
  PAN: 'pan',
  DRAG_START: 'dragstart'
};
